import React from 'react';

import ChartUnavailableNotice from 'views/playground/features/data-lab/components/charts/chart-unavailable-notice';

type Props = {
  height?: number;
};

// FunnelChart is Pro-only.
const ConversionFunnelChart: React.FC<Props> = ({ height = 320 }) => (
  <ChartUnavailableNotice
    height={height}
    title="Conversion funnel — out of scope (license restricted)"
    description="Stocked-to-active survival funnel with categorical stage colours, once an @mui/x-charts-pro licence covers FunnelChart."
  />
);

export default ConversionFunnelChart;
